/**
 * Where a notification points, and whether this app can go there itself.
 *
 * The stored url is absolute, built server-side from CLIENT_URL. A link back into
 * this app is handed to the router so the page does not reload; anything else
 * opens in a new tab.
 *
 * The origin comparison decides what this app is willing to route to, so it lives
 * in one place rather than being copied into every list that renders a row — the
 * two copies it replaced had already drifted apart on what to do with a url that
 * will not parse.
 *
 * Only http and https are openable. `javascript:`, `data:` and `file:` all parse
 * and all report an origin of "null", so a plain origin comparison sends them to
 * the new-tab branch rather than rejecting them. Nothing reaches here that the
 * server did not build, and an allowlist costs one line.
 *
 * @param   {string|null|undefined} url
 * @returns {{internal: true, to: string} | {internal: false, href: string} | null}
 *          null when there is nothing safe to open.
 */
const OPENABLE = ['http:', 'https:'];

export default function resolveNotificationLink(url) {
  if (!url) return null;
  try {
    const target = new URL(url, window.location.origin);
    if (!OPENABLE.includes(target.protocol)) return null;
    if (target.origin === window.location.origin) {
      return { internal: true, to: target.pathname + target.search };
    }
    return { internal: false, href: target.href };
  } catch {
    return null;
  }
}
